export default __webpack_public_path__ + "static/media/SFR SECURITE PRO_RGB.dcf0f8ec.jpg";